// extracted by mini-css-extract-plugin
export default {"zebraStripe":"KRC71t_f30BSnCjYqjwc"};